import React, { useState } from 'react'

import {Box, Button, Flex, FormControl, FormLabel, Heading, Input, Stack} from '@chakra-ui/react'

import { axiosInstance } from '../lib/api';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2'

export default function AddBudget() {
    const navigate = useNavigate()

    const [name, setName] = useState("")
    const [amount, setAmount] = useState("")

    const date = new Date()

    const handleSubmit = (e) => {
        e.preventDefault();
        alert('submitting')
        axiosInstance.post('budget/', {
                name: name,
                amount: amount,
                created: date
            })
        .then(res => res.json)
        .then(data => {
            console.log(data)
            navigate('/dashboard')
            Swal.fire({
                position: 'top-end',
                icon: 'success',
                title: 'Budget added successfully',
                showConfirmButton: false,
                timer: 1500
              })
        })
        .catch(err => console.log(err))
    }

  return (
    <Box mt={10}>
        <Heading>Budget</Heading>
        <form onSubmit={handleSubmit} method="post">
        <Flex alignItems={'center'} justifyContent={'center'}>
        <Stack spacing={5}>
        <FormControl id="item" isRequired>
            <FormLabel>Name</FormLabel>
            <Input type={'text'} value={name} onChange={(e) => setName(e.target.value)}/>
        </FormControl>

        <FormControl id="price" isRequired>
            <FormLabel>Amount</FormLabel>
            <Input type={'number'} value={amount} onChange={(e) => setAmount(e.target.value)}/>
        </FormControl>
        <FormControl>
            <Button type={'submit'}>
                Add
            </Button>
        </FormControl>
    </Stack>
    </Flex>
    </form>
    </Box>
  )
}
